import { defaultGrid } from "@helpers/datagrid";
import defaultReducer from "./defaultReducer";

const initialState = {
  open: false,
  grid: defaultGrid,
  periods: [],
  currentWeek: true,
};

export default defaultReducer("PROMO_ANALYSIS_MODAL", initialState);
